module.exports = __webpack_public_path__ + "static/media/logomobile.3aa7e580.png";